export default {
  OUTREACH: 'outreach'
};
